import React from "react";
import "./navbar-style.css"
import Logo from "../../Assets/sanitas-header-logo.png"
import YoutubeLogo from "../../Assets/Socials/YouTube (1).png"
import FacebookLogo from "../../Assets/Socials/Facebook (1).png"
import InstagramLogo from "../../Assets/Socials/Instagram (1).png"
import XLogo from "../../Assets/Socials/Twitter (1).png"
import TikTokLogo from "../../Assets/Socials/Tik Tok.png"
import {ExpandMore, AccountCircle} from "@mui/icons-material";
import classNames from "classnames";
import {useNavigate} from "react-router-dom";
import {KeyboardArrowRight} from "@mui/icons-material";

export enum NAVBAR_ITEMS {
    DESPRE_NOI = "despre-noi",
    ORGANIZATII_MEMBRRE = "organizatii",
    MEMBRI_DE_SINDICAT = "membri-de-sindicat",
    ACTIVITATI = "activitati",
    JURIDIC = "juridic",
    MEDIA = "media",
    PROIECTE = "proiecte",
    CONTACT = "contact",
    INSCRIERE_APLICATIE = "https://sanitas-app-20caf.web.app/register"
}

enum JURIDIC_ITEMS {
    BIBLIOTECA_VIRTUALA = "biblioteca-virtuala",
    LEGISLATIE = "legislatie",
    CCM = "ccm",
}

enum MEDIA_ITEMS {
    PODCAST = "podcast",
    COMUNICATE_DE_PRESA = "comunicate-de-presa",
    APARITII_IN_PRESA = "aparitii-in-presa",
    GALERIE_FOTO = "galerie-foto",
    GALERIE_VIDEO = "galerie-video",
}

enum About_ITEMS {
    ISTORIC= "istoric",
    MISIUNI_SI_OBIECTIVE = "misiuni-si-obiective",
    CONDUCRE= "conducere",
    STATUT = "statut",
}

export const PAGES = {
    ...NAVBAR_ITEMS,
    ...JURIDIC_ITEMS,
    ...MEDIA_ITEMS,
    ...About_ITEMS
}

export function Navbar() {
    const [activeMobile, setActiveMobile] = React.useState(false);
    const [activeDropdownJuridic, setActiveDropdownJuridic] = React.useState(false);
    const [activeDropdownMedia, setActiveDropdownMedia] = React.useState(false);
    const [activeDropdownAbout, setActiveDropdownAbout] = React.useState(false);
    const [activeDropdownProiecte, setActiveDropdownProiecte] = React.useState(false); // ✅ added
    const navigate = useNavigate();
    console.log({activeDropdownJuridic, activeDropdownMedia})
    return <div className={'header-wrapper'}>
        <div className={"header"}>
            <div className={"header-logo-wrapper"}>
                <img className={"header-logo"} src={Logo} onClick={() => navigate("/")}
                     alt={"logo"}/>
           
            </div>
             
          <div className="social-box">
  <div
    className="header-login-wrapper"
    onClick={() => window.open("https://sanitas-app-20caf.web.app/", "_blank")}
  >
    <AccountCircle className="header-account-icon" />
    <span className="header-login-text">Accesează aplicația</span>
  </div>

  <div className="social-icons">
    <a
      href="https://www.youtube.com/@Sanitas-v7h"
      target="_blank"
      rel="noreferrer"
    >
      <img src={YoutubeLogo} alt="YouTube" />
    </a>
    <a
      href="https://www.facebook.com/sanitas.bucuresti/"
      target="_blank"
      rel="noreferrer"
    >
      <img src={FacebookLogo} alt="Facebook" />
    </a>
  </div>
</div>
        </div>
        <div className={classNames("navbar", activeMobile && "active")}>
            <div className={classNames("nav-menu", activeMobile && "active")}>
            <div className={"navbar-item"}>
                    <a onClick={() => {
                        setActiveDropdownAbout(prevState => !prevState)
                    }}>Despre noi<ExpandMore/></a>
                    <div className={classNames("dropdown", activeDropdownAbout ? "active-dropdown" : "erase")}>
                        <a href={About_ITEMS.ISTORIC}>Istoric</a>
                        <a href={About_ITEMS.MISIUNI_SI_OBIECTIVE}>Misiuni si obiective</a>
                        <a href={About_ITEMS.CONDUCRE} className={"last"}>Conducere</a>
                        <a href={About_ITEMS.STATUT}>Statut</a>

                    </div>
                </div>
                <div className={"navbar-item"}>
                    <a href={NAVBAR_ITEMS.ORGANIZATII_MEMBRRE}>Organizatii membre</a>
                </div>
                <div className={"navbar-item"}>
                    <a href={NAVBAR_ITEMS.MEMBRI_DE_SINDICAT}>Membri de sindicat</a>
                </div>
                {/* <div className={"navbar-item"}>
                    <a href={NAVBAR_ITEMS.ACTIVITATI}>Activitati</a>
                </div> */}
                <div className={"navbar-item"}>
                    <a onClick={() => {
                        setActiveDropdownJuridic(prevState => !prevState)
                    }}>Juridic<ExpandMore/></a>
                    <div className={classNames("dropdown", activeDropdownJuridic ? "active-dropdown" : "erase")}>
                        {/* <a href={JURIDIC_ITEMS.BIBLIOTECA_VIRTUALA}>Biblioteca Virtuala</a> */}
                        <a href={JURIDIC_ITEMS.LEGISLATIE}>Legislatie</a>
                        <a href={JURIDIC_ITEMS.CCM} className={"last"}>CCM-uri</a>
                    </div>
                </div>
                <div className={"navbar-item"}>
                    <a onClick={() => {
                        setActiveDropdownMedia(prevState => !prevState)
                    }}>Media<ExpandMore/></a>
                    <div className={classNames("dropdown", activeDropdownMedia ? "active-dropdown" : "erase")}>
                        <a href={MEDIA_ITEMS.PODCAST}>Podcasturi</a>
                        <a href={MEDIA_ITEMS.COMUNICATE_DE_PRESA}>Știri</a>
                        {/* <a href={MEDIA_ITEMS.APARITII_IN_PRESA}>Aparitii in presa</a>
                        <a href={MEDIA_ITEMS.GALERIE_FOTO}>Galerie foto</a>
                        <a href={MEDIA_ITEMS.GALERIE_VIDEO} className={"last"}>Galerie video</a> */}
                    </div>
                </div>

               <div className={"navbar-item"}>
  <a onClick={() => { setActiveDropdownProiecte(prev => !prev) }}>
    Proiecte<ExpandMore/>
  </a>
  <div className={classNames("dropdown", activeDropdownProiecte ? "active-dropdown" : "erase")}>
    <a onClick={() => navigate("/proiecte")} className={"last"}>Toate proiectele</a>
  </div>
</div>

                <div className={"navbar-item"}>
                    <a href={NAVBAR_ITEMS.CONTACT}>Contact</a>
                </div>
                <div className={"navbar-item cta"}>
                  <a
                    href={NAVBAR_ITEMS.INSCRIERE_APLICATIE}
                    className="nav-button"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Înscriere aplicație
                  </a>
                </div>
            </div>

            <div className={"mobile-navbar"} onClick={() => {
                setActiveMobile((prevState) => !prevState)
            }}>
                <div className={classNames("hamburger", activeMobile && "active")}>
                    <span className={"bar"}></span>
                    <span className={"bar"}></span>
                    <span className={"bar"}></span>
                </div>
                Menu
            </div>
        </div>
    </div>
}
